/* tslint:disable */
/* eslint-disable */
/**
 * Sellsen API
 * Ürün Tarama ve SP-API Entegrasyonu
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the OrderFlagDTO interface.
 */
export function instanceOfOrderFlagDTO(value) {
    return true;
}
export function OrderFlagDTOFromJSON(json) {
    return OrderFlagDTOFromJSONTyped(json, false);
}
export function OrderFlagDTOFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'color': json['color'] == null ? undefined : json['color'],
    };
}
export function OrderFlagDTOToJSON(json) {
    return OrderFlagDTOToJSONTyped(json, false);
}
export function OrderFlagDTOToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'name': value['name'],
        'color': value['color'],
    };
}
